export default "/images/vendor/flag-icon-css/flags/4x3/ge.svg?98cf9dc189b05e67103c0dcff4b7a982";